import type { CourseEvaluatorReviewItemType } from "../types/reviewTypes";

export const COURSE_EVALUATOR_REVIEW_ITEM_TYPE_LABELS: Record<CourseEvaluatorReviewItemType, string> = {
  moduleDescription: "Module Description",
  externalLink: "External Link",
  discussion: "Discussion",
  checklist: "Checklist",
  quiz: "Quiz",
  file: "File Topic",
  htmlContent: "HTML Content",
  link: "External Link",
  ile: "Axio ILE",
  webpage: "Webpage",
};
